export default __webpack_public_path__ + "media/images/girl-phone-cfde6e5b3fd3105b85f1458739a80530.jpeg";